import React, { FC } from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import type { IconProps } from '@icons';

// Call at module scope: flushSync can't render synchronously inside React render or effects.
export const getIconUrl = (Icon: FC<IconProps>, props?: IconProps) => {
  const container = document.createElement('div');
  const root = createRoot(container);
  flushSync(() => root.render(<Icon {...props} />));
  const svg = container.firstElementChild;
  root.unmount();
  if (!svg) throw new Error('getIconUrl: icon did not render synchronously');
  return `data:image/svg+xml,${encodeURIComponent(
    new XMLSerializer().serializeToString(svg)
  )}`;
};
